import CsvPage from "./routes/CsvPage";
import XmlPage from "./routes/XmlPage";
import Header from "./components/Header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<XmlPage />}></Route>
          <Route path="/csv" element={<CsvPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
